<template>
  <el-dialog title="Produkte" :visible="show" @close="$emit('close')">
    <div class="row">
      <div class="col-sm-12">
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Name</th>
              <th>Menge</th>
              <th>Geliefert</th>
              <th>Preis</th>
              <th>Summe</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in orderProducts" :key="product.id">
              <td v-text="product.name"></td>
              <td class="text-right" v-text="product.pivot.quantity"></td>
              <td class="text-right" v-text="product.pivot.completed_quantity"></td>
              <td class="text-right">{{ product.pivot.price | priceFromCentEuro }}</td>
              <td class="text-right">{{ (product.pivot.quantity * product.pivot.price) | priceFromCentEuro }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr style="border-top: 4px double;">
              <td>Summe:</td>
              <td class="text-right">{{ orderQuantitySum }}</td>
              <td></td>
              <td class="text-right">{{ orderSum | priceFromCentEuro }}</td>
            </tr>
          </tfoot>
        </table>
        <br>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'

export default {
  components: { [Dialog.name]: Dialog },
  props: ['show', 'orderProducts'],
  computed: {
    orderSum () {
      return this.orderProducts.reduce((sum, product) => sum + (product.pivot.quantity * product.pivot.price), 0)
    },
    orderQuantitySum () {
      return this.orderProducts.reduce((sum, { pivot }) => sum + pivot.quantity, 0)
    }
  }
}
</script>

<style>
</style>
